module.exports = __webpack_public_path__ + "static/media/print-instrucoes-conta-1.c2f1d044.png";